import React from "react";
import './BracketMasthead.css';
import {isAllByes} from "utilities/js/bracket/RoundHelper";
import { navigateToAccountPage } from "utilities/js/NavigationHelper";
import { navigateToView, navigateToCreate } from "utilities/js/NavigationHelper";
import { makeNewHeader } from "utilities/js/styling/observerCreator";
import CookieManager from "utilities/js/localstorage/CookieManager";
import Constants from "utilities/js/Constants";
import ScrollHelper from "components/reusable/ScrollHelper";
import { NavigatorWrapper } from "components/reusable/NavigatorWrapper";
import { isLoggedIn } from "utilities/js/ActionLibrary";

const resetIcon = Constants.ICON_RESET;
const viewIcon = Constants.ICON_VIEW_ONLY;
const editIcon = Constants.ICON_EDIT;
const publishIcon = Constants.ICON_PUBLISH;
const settingsIcon = Constants.ICON_SETTINGS;


const cookieManager = new CookieManager();


class BracketMasthead extends React.Component {

    constructor(props){
        super(props);
        this.bracketControlRef = React.createRef();

        this.state = {
            roundToDisplay: 'All'
        };

        this.changeRoundToDisplay = this.changeRoundToDisplay.bind(this);
        this.navigateToAccountPage = this.navigateToAccountPage.bind(this);
        this.navigateToViewOnly = this.navigateToViewOnly.bind(this);
        this.navigateToCreate = this.navigateToCreate.bind(this);
    }

    componentDidMount(){
        let mql = window.matchMedia("(max-width: 700px)");
        if(mql.matches){
            let headerContainer = document.querySelector('.bracket-header-container')
            makeNewHeader(headerContainer, {selector: '.brackset-header-light'});
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.contestantMap && prevProps.contestantMap !== this.props.contestantMap){
            this.updateRoundToDisplay('All');
        }
    }

    navigateToAccountPage(){
        navigateToAccountPage({accountId: this.props.bracketRecord?.created_by._id, routerNav: this.props.navigate})
    }

    navigateToViewOnly(event){
        navigateToView({
            bracketId: event.target.dataset.name,
            routerNav: this.props.navigate
        });
    }

    navigateToCreate(event){
        navigateToCreate({
            bracketId: event.target.dataset.name,
            routerNav: this.props.navigate
        })
    }

    get creatorLink(){
        if(this.props.bracketRecord?.created_by?.username){
            return <button className="inline-link" onClick={this.navigateToAccountPage}>{this.props.bracketRecord?.created_by?.username}</button>
        }
    }


    get viewOnlyToggle(){
        if(!this.props.isLocked && this.props.bracketRecord?.view_id){
            return (
            <div className="control-container view-only-icon">
                <img src={viewIcon} className="control-icon" onClick={this.navigateToViewOnly} data-name={this.props.bracketRecord.view_id}></img>
            </div>
            )
        }
    }

    get editToggle(){
        if(this.props.isLocked && this.props.bracketRecord?.bracket_id){
            return (
            <div className="control-container view-only-icon">
                <img src={editIcon} className="control-icon" onClick={this.navigateToCreate} data-name={this.props.bracketRecord.bracket_id}></img>
            </div>
            )
        }
    }

    get settingsControl(){
        if(!this.props.isLocked && this.props.onSettingsClick){
            return (
            <div className="control-container settings-icon-container">
                <img src={settingsIcon} className="control-icon-major" onClick={this.props.onSettingsClick}></img>
            </div>
            )
        }
    }

    get publishControlClass(){
        let className = 'control-container publish-icon-container';
        if (!isLoggedIn()) {
            className += ' disabled';
        }
        return className;
    }

    get publishControl(){
        if(!this.props.isLocked && this.props.onPublishClick){
            return (
            <div className={this.publishControlClass}>
                <img src={publishIcon} className="control-icon-major" onClick={this.props.onPublishClick}></img>
            </div>
            )
        }
    }


  getBracketControls(){
    return (
    <div className="bracket-modifiers">

        <div className="bracket-controls-reset">
            {this.viewOnlyToggle}
            {/* {this.editToggle} */}
            {this.getResetBracketButton()}
        </div>
        <div className="bracket-controls" ref={this.bracketControlRef}>
            {this.getRoundControls()}
            <ScrollHelper direction="right"></ScrollHelper>
        </div>

    </div>
    )
  }

  getRoundControls(){
    let elements = [(<div className="control-container round-icon selected" key="All" data-round="All" onClick={this.changeRoundToDisplay}>All</div>)];
    for(let i = 0; i < this.props.bracket.length; i++){
      elements.push(
        (<div className="control-container round-icon" key={i} data-round={i} onClick={this.changeRoundToDisplay}>
        {i+1}
      </div>)
      )
    }

    if(isAllByes(this.props.bracket[0])){
      elements.pop();
    }

    return elements;
  }

  getResetBracketButton(){
    let resetBracketButton = '';
    if(this.props.onReset){
      resetBracketButton = (
      <div className="control-container reset-icon">
        <img src={resetIcon} alt="control-icon" className="control-icon" onClick={this.props.onReset}></img>
      </div>)
    }
    return resetBracketButton;
  }

  changeRoundToDisplay(event){
    let round = event.currentTarget.dataset.round;
    this.updateRoundToDisplay(round);

    if(this.props.onRoundSelect){
        this.props.onRoundSelect(event);
    }
  }

  updateRoundToDisplay(round){
    let roundIcons = this.bracketControlRef.current.querySelectorAll('.control-container.round-icon')
    roundIcons.forEach((icon) => {
      if(icon.className.includes(' selected')){
        icon.className = icon.className.replace(' selected', '');
      }

      if(icon.dataset.round === round){
        icon.className += ' selected';
      }
    })
    this.setState({roundToDisplay: round});
  }


  render(){

        return (
            <div className="bracket-header-container">
                <div className="bracket-header-content">
                    <div className="bracket-header">
                        <div className="bracket-header-main-section">
                            
                            <div className="bracket-name">
                                {this.props.header}
                            </div>
                            <div className="bracket-owner">
                                {this.creatorLink}
                            </div>
                        </div>
                        <div className="bracket-header-actions-section">
                            {this.publishControl}
                            {this.settingsControl}
                        </div>
                    </div>
                    
                    {this.getBracketControls()}
                </div>
                <div className="masthead-debug"></div>
            </div>
        )
  }
}

export default NavigatorWrapper(BracketMasthead);
